import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserRole } from "../utils/Auth"; // 🔥 Beimportáljuk, de a komponensben hívjuk meg
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { motion } from "framer-motion";

const CategoryList = ({
  categories,
  openEditCategoryModal,
  setCategoryToEdit,
  showCategoryActions,
  handleDeleteCategory,
  deleteSuccess,
}) => {
  const navigate = useNavigate();
  const userRole = getUserRole(); // 🔥 Itt hívjuk meg, hogy mindig friss értéket kapjunk

  const handleEditCategory = (category) => {
    setCategoryToEdit(category);
    openEditCategoryModal();
  };

  return (
    <>
      {deleteSuccess && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-3 rounded-lg shadow-lg text-lg font-semibold transition-opacity duration-500 z-50">
          {deleteSuccess}
        </div>
      )}
      <div className="w-full">
        <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8 mt-6">
          {categories.map((category) => (
            <motion.li
              key={category.id}
              onClick={() => navigate(`/category/${category.id}`)}
              className="relative cursor-pointer rounded-xl overflow-hidden shadow-lg transform transition-transform"
              whileHover={{ scale: 1.05 }} // 🔥 Finom hover-effekt a kártyákra
              transition={{ duration: 0.3 }}
            >
              <img
                src={category.imageUrl || "/images/default.jpg"}
                alt={category.name}
                className="w-full h-64 object-cover"
                loading="lazy" // 🔥 Lazy Loading a gyorsabb betöltés érdekében
              />
              <div className="absolute bottom-0 left-0 w-full min-h-[70px] flex items-center justify-center bg-black bg-opacity-60 text-white text-2xl font-semibold text-center px-4">
                <span>{category.name}</span>
              </div>

              {/* ✅ Csak Adminok szerkeszthetik vagy törölhetik */}
              {showCategoryActions && userRole === "Admin" && (
                <div className="absolute top-2 left-0 w-full flex justify-between px-3">
                  {/* ✏️ Editare gomb */}
                  <Button
                    variant="contained"
                    startIcon={<EditIcon />}
                    sx={{
                      bgcolor: "#1976d2",
                      color: "white",
                      "&:hover": { bgcolor: "#1565c0" },
                      borderRadius: "30px",
                      padding: "8px 16px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditCategory(category);
                    }}
                  >
                    Editare
                  </Button>

                  <Button
                    variant="contained"
                    startIcon={<DeleteIcon />}
                    color="error"
                    sx={{
                      borderRadius: "30px",
                      padding: "8px 16px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteCategory(category.id); // ✅ csak ezt hívjuk
                    }}
                  >
                    Ștergere
                  </Button>
                </div>
              )}
            </motion.li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default CategoryList;
